import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { sectionHeading } from "../utils/typography";
type SectionHeadingProps = {
  /** Production index, e.g. "006". */
  index: string;
  /** Small technical label after the index. */
  label: string;
  /** Words before the accented word. */
  titleStart: string;
  /** The single accented word. */
  accent: string;
  /** Words after the accented word. */
  titleEnd?: string;
  body?: string;
  headingId: string;
  className?: string;
};
export function SectionHeading({
  index,
  label,
  titleStart,
  accent,
  titleEnd,
  body,
  headingId,
  className = ""
}: SectionHeadingProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: "0px 0px -10% 0px"
  });
  return <div ref={ref} className={`max-w-3xl ${className}`} data-id="element-371" data-mp="uj7rsfe440t5">
      <motion.p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/45" initial={{
      opacity: 0,
      y: 12
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : undefined} transition={{
      duration: 0.6
    }} data-id="element-372" data-mp="uhoaclgpzjps">
        {index} / {label}
      </motion.p>

      <h2 id={headingId} className={`mt-6 md:mt-7 ${sectionHeading}`} data-id="element-373" data-mp="1oc79r74394ii">
        <span className="block overflow-hidden" data-id="element-374" data-mp="2300luhtytowc">
          <motion.span className="block" initial={{
          y: "110%"
        }} animate={inView ? {
          y: 0
        } : {
          y: "110%"
        }} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-375" data-mp="231v7xzgz3n20">
            {titleStart} <span className="text-[#54f6c6]" data-id="element-376" data-mp="271vlzj05tw8j">{accent}</span>
            {titleEnd ? ` ${titleEnd}` : ""}
          </motion.span>
        </span>
      </h2>

      {body && <motion.p className="mt-5 max-w-xl text-sm leading-7 text-white/55 md:mt-6 md:text-base md:leading-8" initial={{
      opacity: 0
    }} animate={inView ? {
      opacity: 1
    } : undefined} transition={{
      duration: 0.7,
      delay: 0.15
    }} data-id="element-377" data-mp="2lwa8htixnnry">
          {body}
        </motion.p>}
    </div>;
}